import { SET_ITEMS, SET_ITEM_TYPES } from "./types";

export const setItemTypes = (data) => ({
  type: SET_ITEM_TYPES,
  data: data,
});

export const setItems = (data) => ({
  type: SET_ITEMS,
  data: data,
});
